import Store from '@ember-data/store';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import ContactModel from 'donor-elf-web/models/contact';
import ContactsCache, {
  type ContactCustomPropertyInfo,
} from 'donor-elf-web/services/contacts-cache';
import validateContactCustomProperty from 'donor-elf-web/validations/contact-custom-property';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';

interface ComponentArgs {
  contact: ContactModel;
  propertyInfo: ContactCustomPropertyInfo;
  afterSave: () => void;
  onCancel: () => void;
}

export default class ContactDetailsPropertiesCustomPropertyAddExistingComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);
    let validation = validateContactCustomProperty({
      contactsCache: this.contactsCache,
      isNewProperty: false,
    });
    this.changeset = new Changeset(
      { l: args.propertyInfo.l, t: args.propertyInfo.t, v: '' },
      lookupValidator(validation),
      validation,
    );
  }

  @service declare contactsCache: ContactsCache;
  @service declare store: Store;

  changeset?: any;
  @tracked showValidationErrors = false;
  @tracked saving = false;
  @tracked saveError?: any;

  get notListType() {
    return this.args.propertyInfo.t !== 'l';
  }

  @action
  async save() {
    await this.changeset.validate();
    if (this.changeset.get('isValid')) {
      this.saving = true;
      try {
        let saveCustomProperty = this.store.createRecord('custom-property', {
          contactId: this.args.contact.id,
          l: this.args.propertyInfo.l,
          t: this.args.propertyInfo.t,
          v: this.changeset.get('v'),
          o: this.changeset.get('o'),
        });
        await saveCustomProperty.save();
        if (saveCustomProperty.customPropertyInfo != null) {
          this.contactsCache.updateCustomPropertyInfo(
            saveCustomProperty.customPropertyInfo,
          );
        }
        await this.args.contact.reload();
        this.changeset = undefined;
        this.args.afterSave();
      } catch (e) {
        this.saveError = e;
      }
      this.saving = false;
    } else {
      this.showValidationErrors = true;
    }
  }
}
